/*
 * @Author: zhu.huijun
 * @Date: 2021-06-21 10:39:37
 * @Last Modified by: zhu.huijun
 * @Last Modified time: 2021-07-06 15:21:38
 */
import React, { useEffect, useState } from 'react';
import { i18n } from 'fishx';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

import { Tabs, Spin } from '@whalecloud/fdx';
import { SearchTablePage } from '@/components';

import styles from './index.module.less';

const { TabPane } = Tabs;

const ProtalTabs = props => {
  const { tabPanesGroup = [], defaultActiveKey, modelKey, loading = false } = props;
  const [activeKey, setActiveKey] = useState();

  useEffect(() => {
    if (defaultActiveKey) {
      setActiveKey(defaultActiveKey);
    } else if (!isEmpty(tabPanesGroup)) {
      setActiveKey(get(tabPanesGroup, '0.key'));
    }
  }, [defaultActiveKey]);

  const handleTabChange = key => setActiveKey(key);

  const renderComponent = () => {
    const selectedTab = tabPanesGroup.find(it => it.key === activeKey);
    if (!selectedTab) {
      return '';
    }
    let page;
    const compProps = get(selectedTab, 'compProps') || {};
    if (selectedTab.type === 'searchTablePage') {
      page = <SearchTablePage modelKey={modelKey} {...compProps} />;
    } else {
      page = selectedTab.component;
    }
    return page;
  };

  return (
    <div className={`noFormFlex ${styles.tabComp}`}>
      <div className={styles.tabBox}>
        <Tabs
          activeKey={activeKey}
          onChange={handleTabChange}
        >
          {
            tabPanesGroup.map(it => (
              <TabPane key={it.key} tab={i18n(it.name)} />
            ))
          }
        </Tabs>
      </div>
      <Spin spinning={loading}>
        <div className={styles.tabComponent}>
          {
            renderComponent()
          }
        </div>
      </Spin>
    </div>
  );
};

export default ProtalTabs;
